// extracted by mini-css-extract-plugin
export default {"SimplePlayer":"_65f0Kv","simplePlayer":"_65f0Kv","mediaButton":"s0pG7Q","icon":"GEV2TJ","pausing":"XEm585","playing":"IjRUtQ"};